import { render } from "./Stoppage.vue?vue&type=template&id=65f08169&scoped=true"
import script from "./Stoppage.vue?vue&type=script&lang=js"
export * from "./Stoppage.vue?vue&type=script&lang=js"

import "./Stoppage.vue?vue&type=style&index=0&id=65f08169&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f08169"]])

export default __exports__